import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-home-update-details-v2',
  templateUrl: './home-update-details-v2.component.html',
  styleUrl: './home-update-details-v2.component.scss'
})
export class HomeUpdateDetailsV2Component {
  isBrowser: boolean;
 
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
 
  trackEvent(event: string): void {
    if (!this.isBrowser) return;
    window.analytics.track(event);
  }
}
